import React, {FC, forwardRef, ReactNode, useState, useImperativeHandle} from "react"

import {InjectIntl} from "@irati/utils/lang"
import Modal from "@irati/ui/src/GenericModal"

import Content from "./Content"
import {Back} from "./styled"

export interface OnboardingModalSteps {
  description: string,
  image: string,
  title: string,
  actions?: ReactNode
}

interface Props extends InjectIntl {
  steps: OnboardingModalSteps[]
}

const OnboardingModal: FC<Props> = forwardRef(({steps}, ref) => {
  const [show, setShow] = useState(true)
  const [currentStep, setCurrentStep] = useState(0)

  const nextStep = () => {
    if (currentStep >= 0 && currentStep <= steps.length) {
      setCurrentStep(currentStep + 1)
    }
    if (currentStep === steps.length) {
      setShow(false)
    }
  }
  useImperativeHandle(ref, () => ({
    hideModal() {
      setShow(false)
    }
  }))

  return (
    <Modal show={show} hideActions critical mobileFullHeight>
      <Back currentStep={currentStep} onClick={() => setCurrentStep(currentStep - 1)} />
      <Content steps={steps} ref={ref} currentStepNumber={currentStep} handleClick={nextStep} />
    </Modal>
  )
})

export default OnboardingModal
